export const BRAND_NAME = 'CATSMOKER';
export const BRAND_DISPLAY_NAME = 'CatSmoker';
export const BRAND_NAME_LOWER = BRAND_NAME.toLowerCase();
export const BRAND_URL = `https://${BRAND_NAME_LOWER}.vercel.app`;
export const BRAND_GITHUB_URL = `https://github.com/${BRAND_NAME_LOWER}`;
export const BRAND_GITHUB_API_URL = `https://api.github.com/users/${BRAND_NAME_LOWER}`;
export const BRAND_YOUTUBE_URL = `https://www.youtube.com/@${BRAND_NAME}`;
export const BRAND_PAYPAL_URL = `https://www.paypal.me/${BRAND_NAME_LOWER}`;
export const BRAND_BINANCE_QR_URL = `https://app.binance.com/uni-qr/cpro/${BRAND_NAME}?l=en&r=${BRAND_NAME}&uc=app_square_share_link&us=copylink`;
export const BRAND_TELEGRAM_URL = `https://t.me/${BRAND_NAME}_BOT`;
export const BRAND_TWITTER_URL = 'https://twitter.com/CATSM0KER';
export const BRAND_INSTAGRAM_URL = 'https://www.instagram.com/catsm0ker/';
